module.exports = __webpack_public_path__ + "img/arrowBack.33d1d8a9.svg";